import { useMutation } from 'react-query';
import {PartnerApi} from "../../api/partner.api";
import {useOpportunitiesStore} from "../../store/opportunities.store";
import {useCompanyStore} from "../../store/company.store";
import {useDashboardStore} from "../../store/dashboard.store";

export const useDashboard = () => {
    const setDashboard= useDashboardStore((state) => state.setDashboard);

    return useMutation(PartnerApi.dashboard, {
        onSuccess: (data) => {
            setDashboard(data);
        },
        onError: (error) => {
            console.error('Login failed:', error);
        },
    });
};